import { Box, Stack, Tooltip, Typography } from '@chronosphereio/chrono-ui';
import React from 'react';
import { TimeRangeControls } from '@/components';
import { QueryOptionsDefinition } from '@/core';

export function DisabledTimeRangeControls({
  timeOverride,
  children,
}: {
  timeOverride: QueryOptionsDefinition['time'];
  children?: React.ReactNode;
}) {
  return (
    <Stack direction="row" justifyContent="space-between" alignItems="center">
      <Typography variant="h4">Preview</Typography>
      <Stack direction="row" spacing={2}>
        {children}
        <Tooltip
          Content={`Relative time override applied (${timeOverride?.start}). Uncheck 'Override dashboard time' in query settings to enable the dashboard time range.`}
        >
          <div>
            <Box
              sx={{
                pointerEvents: 'none',
                opacity: 0.5,
              }}
            >
              <TimeRangeControls showTimeRangeWindowControls showRefreshInterval />
            </Box>
          </div>
        </Tooltip>
      </Stack>
    </Stack>
  );
}
